module.exports = __webpack_public_path__ + "img/experiencies.23d8ace4.png";